import './Login.css'
import { useState, ReactNode, FormEvent } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getValidationErrors, resetPassword } from '../api/Auth';
import NewPasswordFields, { PasswordFormErrors, useNewPassword } from './password/NewPasswordFields';

// Сколько показывать сообщение об успехе перед переходом на вход.
const REDIRECT_DELAY_MS = 2000;

function ForgotPasswordConfirmation(): ReactNode {
    const { t } = useTranslation(['forgot_pass_confirm', 'base']);
    const navigate = useNavigate();
    const location = useLocation();

    // Ссылка из письма: /forgot-pass-confirm?token=...
    const token = new URLSearchParams(location.search).get('token') ?? "";

    const newPassword = useNewPassword();
    const [errors, setErrors] = useState<string[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [isDone, setIsDone] = useState<boolean>(false);

    function submitForm(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();

        if (!newPassword.isValid || isSubmitting) {
            return;
        }

        setErrors([]);
        setIsSubmitting(true);

        resetPassword({ token: token, newPassword: newPassword.password }).then(() => {
            setIsDone(true);
            setTimeout(() => navigate('/login', { replace: true }), REDIRECT_DELAY_MS);
        }).catch((error) => {
            const serverErrors = getValidationErrors(error);
            setErrors(serverErrors.length > 0 ? serverErrors : [t('error')]);
            setIsSubmitting(false);
        });
    }

    if (!token) {
        return (
            <div className='form-page'>
                <div className='form-page-container'>
                    <div className="password-form-error">{t('invalid_link')}</div>
                    <a className='forgot-pass t-14' href='/forgot-pass'>{t('request_new_link')}</a>
                </div>
            </div>
        );
    }

    if (isDone) {
        return (
            <div className='form-page'>
                <div className='form-page-container'>
                    <div className="password-form-success">{t('success')}</div>
                </div>
            </div>
        );
    }

    return (
        <div className='form-page'>
            <div className='form-page-container'>
                <Form onSubmit={submitForm}>
                    <NewPasswordFields state={newPassword} disabled={isSubmitting} />
                    <Button variant="primary" type="submit" disabled={!newPassword.isValid || isSubmitting}>
                        {t('submit_button_text')}
                    </Button>
                </Form>
                <PasswordFormErrors errors={errors} />
            </div>
        </div>
    )
}

export default ForgotPasswordConfirmation;
